import { ErrorSummary } from 'nhsuk-react-components';

const QuestionErrorSummary = ({ validationIssues }) => {
    return (
        <ErrorSummary aria-labelledby="error-summary-title" role="alert" tabIndex={-1}>
            <ErrorSummary.Title id="error-summary-title">There is a problem</ErrorSummary.Title>
            <ErrorSummary.Body>
                <p>Validation errors have been identified with the following questions:</p>
                <ErrorSummary.List className="margaret">
                    {validationIssues.map(({ question_id, error }) => (
                        <li>
                            <b>
                                {question_id} - {error}
                            </b>
                        </li>
                    ))}
                </ErrorSummary.List>
            </ErrorSummary.Body>
        </ErrorSummary>
    );
};

export default QuestionErrorSummary;
